import {i18n2} from '../../i18n/i18n';

const formatDate = (instance, attended) => {
  const {expiration_Date} = instance;
  const {status, onTime} = attended;
  if (status === 1) {
    if (onTime) {
      return i18n2._('Se encuentra realizado en tiempo');
    } else {
      return i18n2._('No se encuentra realizado en tiempo');
    }
  }
  const today = new Date();
  const date_vig = new Date(expiration_Date);
  if (date_vig.getFullYear() < today.getUTCFullYear()) {
    return i18n2._('Se encuentra vencido');
  }

  if (date_vig.getFullYear() > today.getUTCFullYear()) {
    const myMonth = date_vig.getMonth() + 1;
    return (
      i18n2._('Vence el: ') +
      date_vig.getDate() +
      '/' +
      myMonth +
      '/' +
      date_vig.getFullYear()
    );
  }

  if (
    date_vig.getDate() === today.getUTCDate() &&
    date_vig.getMonth() === today.getUTCMonth()
  ) {
    return i18n2._('Vence Hoy');
  }
  if (date_vig.getMonth() < today.getUTCMonth()) {
    return i18n2._('Vencido');
  }
  if (date_vig.getMonth() === today.getUTCMonth()) {
    if (date_vig.getDate() > today.getUTCDate()) {
      const diffDate = date_vig.getDate() - today.getUTCDate();
      return i18n2._('Falta') + diffDate + i18n2._('dia/s para que venza');
    } else {
      return i18n2._('Vencido');
    }
  } else {
    const myMonth = date_vig.getMonth() + 1;
    return (
      i18n2._('Vence el: ') +
      date_vig.getDate() +
      '/' +
      myMonth +
      '/' +
      date_vig.getFullYear()
    );
  }
};

export default formatDate;
